import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-recruitee-logo',
  standalone: true,
  templateUrl: './recruitee-logo.component.html',
  styleUrls: ['./recruitee-logo.component.less'],
  host: {
    '[class]': 'type',
  },
})
export class RecruiteeLogoComponent {
  @Input() public type: 'full-logo' | 'signet' = 'full-logo';
}
